import { render, staticRenderFns } from "./MachineDetailsNewDashboard.vue?vue&type=template&id=5c3039fd&scoped=true"
import script from "./MachineDetailsNewDashboard.vue?vue&type=script&lang=js"
export * from "./MachineDetailsNewDashboard.vue?vue&type=script&lang=js"
import style0 from "./MachineDetailsNewDashboard.vue?vue&type=style&index=0&id=5c3039fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3039fd",
  null
  
)

export default component.exports